<template lang="pug">
div
  app-modal-assinar-titulo(
    v-if="showModalAssinatura",
    :idsProcessos="idsProcessosAssinatura",
    @closeModal="closeModalAssinatura"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  app-modal-avocar(
    v-if="showModalAvocar && idsProcessos.length > 0",
    @closeModal="showModalAvocar = false",
    :idsProcessos="idsProcessos"
  )
  app-modal-solicitar-retificacao(
    v-if="solicitarRetificacao",
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :setor="setorSelecionado",
    @closeModal="solicitarRetificacao = false"
  )
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_RESPONSAVEL",
    @refresh="refresh"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido",
      :showFiltroSetor="true"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="showButtonOrdemServico",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro"
    :infoPrazos="showInfoVencimento() && infoPrazos"
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise"
    @executar="executar"
  )
  span.padding-left(v-if="showButtonOrdemServico") {{ 'Processos Selecionados: ' + idsProcessos.length }}
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import AppListagem from '@/components/AppListagem.vue'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalAvocar from '@/screens/analise/components/modal/AppModalAvocar'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalAssinarTitulo from '@/screens/analise/components/AppModalAssinarTitulo'
import AppModalSolicitarRetificacao from '@/screens/analise/components/modal/AppModalSolicitarRetificacao'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {

  beforeRouteLeave (to, from, next) {
    if (to.name !== 'ordem-servico') {
      this.setProcessoSelecionados({ processos: [], map: true })
    }
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalAvocar,
    ModalTrocarResponsavel,
    AppModalAssinarTitulo,
    AppModalSolicitarRetificacao
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('RELATORIO_GRF_CAF_CREDENCIADOS'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      setoresInfoVencimento: [ 'GAC', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GDA', 'GRF', 'GAM', 'GEA', 'DJ', 'CDI', 'CPAV', 'GP', 'GIT', 'GRF_CAF',
        'GCG_CGIR'],
      processosSelecionados: [],
      showModalResponsavel: false,
      disabledAnalisar: false,
      showModalVisualizarProcesso: false,
      solicitarRetificacao: false,
      showModalAssinatura: false,
      showModalAvocar: false,
      processoTrocado: null,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      setorSelecionado: null,
      protocolo: null,
      idsProcessosAssinatura: [],
      idsProcessos: [],
      configuracaoFiltro: {
        filtroCredenciado: filtro?.filtroCredenciado?.RELATORIO_GRF_CAF_CREDENCIADOS,
        filtroCredenciadoVistoria: filtro?.filtroCredenciadoVistoria?.RELATORIO_GRF_CAF_CREDENCIADOS,
        filtroCredenciadoGeo: filtro?.filtroCredenciadoGeo?.RELATORIO_GRF_CAF_CREDENCIADOS
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone-credenciado', icone: 'comment-alt' },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'interessado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Setor', propriedade: 'setor', ordem: 5, acoes: [], formatter: this.formataSetor, exibir: () => true },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipoProcessoNome', ordem: 5, acoes: [] },
        { id: 7, titulo: 'Credenciado GEO', propriedade: 'credenciado', ordem: 5, acoes: [] },
        { id: 8, titulo: 'Credenciado VISTORIA', propriedade: 'credenciadoVistoria', ordem: 5, acoes: [] },
        { id: 9, titulo: 'Situação do processo', propriedade: 'status', ordem: 6, acoes: [] },
        {
          id: 9, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso }
          ]
        }
      ],

      usuario: null,
      filtroRapido: null,
      isPa: process.env.ESTADO === 'pa'
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  beforeDestroy () {
    this.ordemServicoClear()
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    ...mapState({
      listaProcessosAuxiliar: state => state.ordemServico.listaProcessosAuxiliar
    }),
    showButtonOrdemServico () {
      return false
    }
  },

  methods: {

    ...mapActions({
      ordemServicoClear: 'ordemServico/clear',
      setListaProcessoAuxiliar: 'ordemServico/setListaProcessoAuxiliar',
      retornarSetor: 'processo/retornarSetor',
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados',
      getPvtnAtivo: 'vtn/getPvtnAtivo',
      checkAnaliseManual: 'processo/checkAnaliseManual',
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      iniciarValidaoManual: 'processo/iniciarValidaoManual',
      exportarCsvAnalise: 'processo/exportarCsvAnalise'
    }),

    formataSetor (prop) {
      return setoresFormatado[prop.setor]
    },

    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario?.perfilSelecionado?.codigo)
    },

    showInfoVencimento () {
      return !!this.setoresInfoVencimento.find(setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo)
    },

    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()
      this.exportarCsvAnalise(this.filtro)
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoProcessoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    async EMITIR_DAE (_this, { item }) {
      this.$router.push({
        name: 'financeiro/dae/CadastroDae',
        params: {
          idProcesso: item.id
        }
      })
    },
    VISUALIZAR_COM_MODAL: (context) => {
      this.showModalResponsavel = true
    },
    GERENCIAR_PROCESSO: () => {
      return 'Gerenciar processo'
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.padding-left {
  padding-left: 25px;
}

@media (max-width: 780px) {
  .card-container {
    margin: 0 0 15px 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaCredenciados.vue